import { useCallback, useState } from "react";

// =======================================================
// useAppointmentModal
// -------------------------------------------------------
// Manages the open/closed state of appointment modals.
//
// Responsibilities:
// - Open and close the add appointment modal
// - Open and close the edit appointment modal
// - Store the currently selected appointment
// - Store the delete-hover state
//
// Appointment form data remains inside Home.js for now.
// =======================================================

const useAppointmentModal = () => {
  const [addModalIsOpen, setAddModalIsOpen] = useState(false);
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isDeleteHover, setIsDeleteHover] = useState(false);

  // =======================================================
  // Open Add Modal
  // -------------------------------------------------------
  // Opens the modal used to create a new appointment.
  // =======================================================

  const openAddModal = useCallback(() => {
    setAddModalIsOpen(true);
  }, []);

  // =======================================================
  // Open Edit Modal
  // -------------------------------------------------------
  // Stores the selected appointment and opens the edit modal.
  // =======================================================

  const openEditModalState = useCallback((appointment) => {
    setSelectedAppointment(appointment);
    setEditModalIsOpen(true);
  }, []);

  // =======================================================
  // Close Appointment Modals
  // -------------------------------------------------------
  // Closes both appointment modals and clears modal state.
  // =======================================================

  const closeAppointmentModals = useCallback(() => {
    setAddModalIsOpen(false);
    setEditModalIsOpen(false);
    setSelectedAppointment(null);
    setIsDeleteHover(false);
  }, []);

  return {
    addModalIsOpen,
    editModalIsOpen,
    selectedAppointment,
    isDeleteHover,
    setIsDeleteHover,
    openAddModal,
    openEditModalState,
    closeAppointmentModals,
  };
};

export default useAppointmentModal;